import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'MİGA Yapı',
  description = '30 yılı aşkın deneyimimizle İstanbul ve Kocaeli\'de kentsel dönüşüm, yeni inşaat ve tadilat hizmetleri sunuyoruz.',
  keywords = 'inşaat firması istanbul, kentsel dönüşüm, miga yapı, inşaat şirketi',
  canonical,
  type = 'website',
  image = '/og-image.jpg',
  noindex = false,
  structuredData = null
}) => {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const fullTitle = title === 'MİGA Yapı' 
    ? 'MİGA Yapı - Gayrimenkul Geliştirme | İnşaat & Kentsel Dönüşüm'
    : `${title} | MİGA Yapı`;

  // Default business structured data
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": siteUrl,
    "name": "MİGA Yapı",
    "description": "İstanbul ve Kocaeli'de kentsel dönüşüm, yeni inşaat ve tadilat hizmetleri",
    "url": siteUrl,
    "telephone": "+90-212-433-0148",
    "email": "info@migayapi.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Merkez Mahallesi Güngören Caddesi No:47",
      "addressLocality": "Bağcılar",
      "addressRegion": "İstanbul",
      "postalCode": "34200",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 41.0296188,
      "longitude": 28.8648011
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "13:00"
      }
    ],
    "priceRange": "$$",
    "image": `${siteUrl}/og-image.jpg`,
    "sameAs": [
      "https://www.instagram.com/migayapi",
      "https://www.youtube.com/@migayapi"
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "İstanbul"
      },
      {
        "@type": "City",
        "name": "Kocaeli"
      }
    ],
    "knowsAbout": [
      "Kentsel Dönüşüm",
      "İnşaat",
      "Tadilat",
      "Güçlendirme",
      "Proje Tasarım"
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${image}`} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="MİGA Yapı" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical || siteUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${image}`} />
      
      {/* Additional SEO */}
      <meta name="author" content="MİGA Yapı" />
      <meta name="publisher" content="MİGA Yapı" />
      <meta name="geo.region" content="TR-34" />
      <meta name="geo.placename" content="İstanbul" />
      <meta name="geo.position" content="41.0296188;28.8648011" />
      <meta name="ICBM" content="41.0296188, 28.8648011" />
      <html lang="tr" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
